import { DatePicker, Space } from 'antd';
import { MDBBadge, MDBCard, MDBCardBody, MDBCol, MDBContainer, MDBFooter, MDBPageItem, MDBPageNav, MDBPagination, MDBRow } from 'mdbreact';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import axios from '../../authAxios';
import styles from './trackStickerVisa.module.css';


const { RangePicker } = DatePicker;

const TrackStickerVisa = () => {
    const history = useHistory()
    const [dateRange, setDateRange] = useState({
        startDate: moment('2000-06-29', 'YYYY-MM-DD').format(),
        endDate: moment('2025-08-30', 'YYYY-MM-DD').format(),
    }) // date for stickervisa date filter

    // const [paginatedItems, setPaginatedItems] = useState([])
    const [paginate, setPaginate] = useState({
        page: 1,
        nextPage: 1,
        prePage: 1,
        totalPages: 1,
        total: 0,
        data: [],
        total_data: []
    })
    const [data, setData] = useState([])
    const [statusColor, setStatusColor] = useState({
        gray_status_color: '#AAAAAA',
        red_status_color: '#FB4A36',
        orange_status_color: '#FFAA00',
        green_status_color: '#26AF48',
        not_approved_status_color: '#dc3545',
    })

    const dateFormat = 'DD/MM/YYYY';

    // handle date range
    const handleDateRangeChange = (momentDate) => {
        let start_dt = momentDate[0]._d
        let end_dt = momentDate[1]._d
        setDateRange({
            startDate: moment(start_dt).utc().format(),
            endDate: moment(end_dt).utc().format()
        })
        getStickerVisaData(moment(start_dt).utc().format(), moment(end_dt).utc().format())
    }


    const pagination = (items, currentPage, itemsPerPage) => {

        let current_page = currentPage || 1;
        let items_perPage = itemsPerPage || 2;
        let offset = (current_page - 1) * items_perPage

        let paginated_items = items.slice(offset).slice(0, items_perPage)
        let total_pages = Math.ceil(items.length / items_perPage)

        setPaginate({
            ...paginate,
            page: currentPage,
            nextPage: ((total_pages > current_page) ? current_page + 1 : total_pages),
            prePage: ((current_page - 1) ? current_page - 1 : 1),
            totalPages: total_pages,
            total: items.length,
            data: paginated_items,
            total_data: items,
        })
        return {
            page: current_page,
            prePage: (current_page - 1) ? current_page - 1 : null,
            nextPage: (total_pages > current_page) ? current_page + 1 : null,
            total: items.length,
            totalPages: total_pages,
            data: paginated_items,
            total_data: items
        }


    }


    const getStickerVisaData = async (start_dt, end_dt) => {
        try {
            const res = await axios.get(`/visa/getStickerVisaApplications?user_id=${localStorage.getItem('user_id')}&start_date=${start_dt}&end_date=${end_dt}`)
            if (res.data?.data === "success") {
                // console.log('get sticker visa => ', res.data)
                setData(res.data?.dataObj)
                // console.log(res.data.dataobj)
                let paginateData = pagination(res.data?.dataObj, paginate.pageNo, 10)
                // console.log('paginationworked', { ...paginateData })
                setPaginate({ ...paginateData })
            } else {
                setData([])
            }
        } catch (error) {
            setData([])
            // throw new Error('Something went wrong!', error)
        }
    }

    useEffect(() => {
        // console.log('date', dateRange)
        // console.log('working!', moment('2019-09-12', 'YYYY-MM-DD').format())
        getStickerVisaData(dateRange.startDate, dateRange.endDate)
    }, [])

    // no data found table
    const showNoDataCard = () => {
        return <MDBRow>
            <MDBCol size="12" md="12" sm="12">
                <br />
                No records found.
                <br />
            </MDBCol>
        </MDBRow>
    }

    const prevPage = () => {
        pagination(data, paginate.prePage, 10)
        //   setPaginate({...paginate, paginate_data})
        // set({ pageNo: paginate.prePage })
    }

    const nextPage = () => {
        pagination(data, paginate.nextPage, 10)
        // setPaginate({...paginate, paginate_data})
    }


    // table header
    const renderMyApplicationTableHeader = () => {

        return <>
            <th style={{ fontWeight: 'bold' }} scope="col">Ref. ID </th>
            {/* <th style={{ fontWeight: 'bold' }} scope="col">Applicants </th> */}
            {/* {this.state.activeItem !== '11' &&<th style={{ fontWeight: 'bold' }} scope="col">COR </th>} */}
            <th style={{ fontWeight: 'bold' }} scope="col">Nationality </th>
            <th style={{ fontWeight: 'bold' }} scope="col">Destination</th>
            <th style={{ fontWeight: 'bold' }} scope="col">Visa Type</th>
            <th style={{ fontWeight: 'bold' }} scope="col">Date of Creation</th>
            {/*  */}
            <th style={{ fontWeight: 'bold' }} scope="col">Departure Date</th>
            <th style={{ fontWeight: 'bold' }} scope="col">Arrival Date</th>
            {/* <th style={{ fontWeight: 'bold' }} scope="col">Visa Duration</th> */}
            <th style={{ fontWeight: 'bold' }} scope="col">Created By</th>
            {/* <th style={{ fontWeight: 'bold' }} scope="col">Processed By</th>
            <th style={{ fontWeight: 'bold' }} scope="col">Processing Center</th> */}
            <th style={{ fontWeight: 'bold' }} scope="col">Application Status</th>
            <th style={{ fontWeight: 'bold' }} scope="col">Action</th>
        </>

    }

    const handleClickStickerVisa = (obj) => {
        // console.log('obj', obj)
        history.push({
            pathname: '/track-sticker-visa/details',
            state: {
                details_id: obj?._id
            }
        })
    }

    const getReadableDate = (givenDate) => {
        let monthNames = ["Jan", "Feb", "Mar", "Apr",
            "May", "Jun", "Jul", "Aug",
            "Sep", "Oct", "Nov", "Dec"];
        var dt = new Date(givenDate)
        var dateStr = dt.getDate() + "-" + monthNames[(dt.getMonth())] + "-" + dt.getFullYear() + " "
        return dateStr
    }

    const capitalize = (s) => {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
    }


    const getBookingStatus = (bookingStatus, applicationObj) => {
        // console.log(bookingStatus)

        if (bookingStatus === "upload_documents") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${statusColor.gray_status_color}`, color: 'white'
            }}>Document Required</MDBBadge>
        } else if (bookingStatus === "review_visa_form") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${statusColor.gray_status_color}`, color: 'white'
            }}>Information Required</MDBBadge>
        } else if (bookingStatus === "payment") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${statusColor.gray_status_color}`, color: 'white'
            }}>Payment Pending</MDBBadge>
        } else if (bookingStatus === "pending_bank_tranfer") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${statusColor.orange_status_color}`, color: 'white'
            }}>Payment Pending</MDBBadge>
        } else if (bookingStatus === "pending_finance_approval") {
            var user_type = localStorage.getItem('user_type')
            var payment_mode = applicationObj.payment_mode
            var payment_status = applicationObj.payment_status
            if (user_type === 'agency_agent' && payment_mode === 'agency_credit') {
                return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                    textTransform: 'none',
                    background: `${statusColor.orange_status_color}`, color: 'white'
                }}>Application Under Review</MDBBadge>
            } else {
                if (payment_mode === 'pay_at_center' && payment_status === 'PENDING') {
                    return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                        textTransform: 'none',
                        background: `${statusColor.orange_status_color}`, color: 'white'
                    }}>Payment Pending</MDBBadge>
                } else if (payment_mode === 'bank_transfer' && payment_status === 'PAID') {
                    return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                        textTransform: 'none',
                        background: `${statusColor.orange_status_color}`, color: 'white'
                    }}>Payment Confirmation Pending</MDBBadge>
                } else { //online or by Admin payment paid
                    return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                        textTransform: 'none',
                        background: `${statusColor.orange_status_color}`, color: 'white'
                    }}>Payment Confirmation Pending</MDBBadge>
                }

            }
        } else if (bookingStatus === "booking_submitted") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${statusColor.green_status_color}`, color: 'white',
            }}>Ready For Submission</MDBBadge>
        } else if (bookingStatus === "payment_pending") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${statusColor.orange_status_color}`, color: 'white'
            }}>Payment Pending</MDBBadge>
        } else if (bookingStatus === "payment_failed") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${statusColor.red_status_color}`, color: 'white'
            }}>Payment Failed</MDBBadge>
        } else if (bookingStatus === "additional_information") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${statusColor.gray_status_color}`, color: 'white'
            }}>Information Required</MDBBadge>
        }//application_submitted
        else if (bookingStatus === "application_submitted") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${statusColor.green_status_color}`, color: 'white'
            }}>Application In Progress</MDBBadge>
        } else if (bookingStatus === "pending_admin_verification") { //
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${statusColor.orange_status_color}`, color: 'white'
            }}>Application Under Review</MDBBadge>
        } else if (bookingStatus === "on_hold") { //
            var hold_type = applicationObj.hold_type
            if (hold_type === 'documents_invalid') {
                return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                    textTransform: 'none',
                    background: `${statusColor.red_status_color}`, color: 'white'
                }}>Document Required</MDBBadge>
            } else if (hold_type === 'visa_information_invalid') {
                return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                    textTransform: 'none',
                    background: `${statusColor.red_status_color}`, color: 'white'
                }}>Information Required</MDBBadge>
            } else {
                return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                    textTransform: 'none',
                    background: `${statusColor.red_status_color}`, color: 'white'
                }}>On Hold</MDBBadge>
            }

        } else if (bookingStatus === "visa_in_process") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${statusColor.green_status_color}`, color: 'white'
            }}>Application In Progress</MDBBadge>
        } else if (bookingStatus === "in_queue") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${statusColor.orange_status_color}`, color: 'white'
            }}>In Queue</MDBBadge>
        } else if (bookingStatus === "application_posted") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${statusColor.orange_status_color}`, color: 'white'
            }}>Application Posted</MDBBadge>
        } else if (bookingStatus === "additional_documents_required") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${statusColor.orange_status_color}`, color: 'white'
            }}>Additional Documents Required</MDBBadge>
        } else if (bookingStatus === "application_approved") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${statusColor.green_status_color}`, color: 'white'
            }}>Approved</MDBBadge>
        }
        else if (bookingStatus === "application_rejected") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${statusColor.not_approved_status_color}`, color: 'white'
            }}>Not Approved</MDBBadge>
        } else if (bookingStatus === "decision_taken") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${statusColor.green_status_color}`, color: 'white'
            }}>Decision Taken</MDBBadge>
        } else if (bookingStatus === "application_cancelled") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${statusColor.orange_status_color}`, color: 'white'
            }}>Application Cancelled</MDBBadge>
        } else {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{ textTransform: 'none', background: `${statusColor.orange_status_color}`, color: 'white' }}>{capitalize(bookingStatus?.replace(/_/g, " "))}</MDBBadge>
        }
    }

    const renderTableBody = () => {
        // console.log("paginate",paginate.data)
        return paginate.data && paginate.data.map((obj, i) => {
            // var created_by_str = i.application_obj.contact_details.first_name + " " + i.application_obj.contact_details.last_name + " - " + i.application_obj.application_created_by_user;
            var created_by_str = obj?.contact_details?.first_name + " " + obj?.contact_details?.last_name;
            
            created_by_str = created_by_str.replace(/[^a-zA-Z-() ]/g, "")//.toUpperCase()
            let craete_on = new Date(obj?.created_on)


            const {
                application_reference_code = obj?.application_reference_code,
                applicants = obj?.total_applicants,// this.showTotalApplicantCount(obj.applicants_data),
                country_of_residence = obj?.origin,
                nationality = obj?.nationality,
                destination = obj?.travelling_to_country,
                created_on = getReadableDate(obj?.created_on),
                created_by = created_by_str,
                // reviewed_by = (obj.application_verified_by_name == null ? "-" : obj.application_verified_by_name),
                reviewed_by = (obj?.application_submitted_by_name == null ? "-" : obj?.application_submitted_by_name),
                // processing_center = obj.application_country + " - " + obj.application_city,
                arrival_date = getReadableDate(obj?.journey_start_date),
                departure_date = getReadableDate(obj?.journey_end_date),
                // application_status = getBookingStatus(obj?.application_state, obj?),
                name = obj?.contact_details?.first_name + ' ' + obj?.contact_details?.last_name,
                mobile_no = obj?.contact_details?.country_code + ' ' + obj?.contact_details?.mobile_no,
                email = obj.contact_details?.email,
                visa_type = obj?.visa_processing_type + " | " + obj?.visa_entry_type
                + " Entry | " + obj?.visa_category,
                visa_duration = obj?.total_days + " " + `${obj?.duration_type === null ? "Days" : capitalize(obj.duration_type)}`,
                isWithInsurance = obj?.is_with_insurance,
                applicantData = obj.applicants_data
            } = obj
            var country = (obj?.application_country == null ? "" : obj?.application_country)
            var city = (obj?.application_city == null ? "" : obj?.application_city)
            var processing_center = country + " - " + city
            return (
                <>
                    <tr >
                        <td style={{ borderLeft: "1px solid #dee2e6", color: '#00000' }}>{application_reference_code}</td>
                        {/* <td className={styles.applicationTextColor}>{applicants}</td> */}
                        {/* {state.activeItem !== '11' && <td className={styles.applicationTextColor}>{country_of_residence}</td>}  */}
                        <td className={styles.applicationTextColor}>{nationality}</td>
                        <td className={styles.applicationTextColor}>{destination}</td>
                        <td className={styles.applicationTextColor}> {visa_duration + " | " + visa_type}</td>
                        <td className={styles.applicationTextColor}>{getReadableDate(craete_on)}</td>
                        {/* <td>{reviewed_by}</td> */}
                        <td className={styles.applicationTextColor}>{arrival_date}</td>
                        <td className={styles.applicationTextColor}> {departure_date}</td>
                        {/* <td className={styles.applicationTextColor}> {visa_duration}</td> */}
                        <td className={styles.applicationTextColor}> {created_by}</td>

                        {/* <td > - </td>
                        <td >{processing_center}</td> */}
                        {/* <td >{application_status}</td> */}
                        <td >
                            <MDBBadge className=" p-2 shadow-none" color="none" style={{
                                textTransform: 'none',
                                background: `gray`, color: 'black',
                            }}>Inquiry Generated</MDBBadge></td>
                        <td >
                            <a style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => handleClickStickerVisa(obj)}>Details</a>
                        </td>
                    </tr>
                    {/* {renderApplicantTableHeader()}</tr>
                {renderApplicantTableData(applicantData)}  */}

                </>
            )
        }
        )
    }

    // conditional data table
    const TableData = () => {
        // console.log("paginate", paginate)
        if (paginate.data.length <= 0) {
            return showNoDataCard()
        } else {
            return <div className="table-responsive-md table-responsive">
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            {renderMyApplicationTableHeader()}
                        </tr>
                    </thead>
                    <tbody>
                        {renderTableBody()}
                    </tbody>
                </table>
            </div>
        }
    }
    return (
        <div>
            {/* <VisaeroJumbotron jumbotrontext="Track Sticker Visa" /> */}
            <div className="mt-0">
                <MDBContainer fluid >
                    <MDBRow >
                        <MDBCol size="12" md="12" sm="12"  >
                            <h4>
                                <b> Track Sticker Visa Application</b>
                            </h4>
                        </MDBCol>
                        <MDBCol size='12' md='12' sm='12'>
                            <MDBCard style={{ width: '100%', minHeight: '300px' }} >
                                <MDBCardBody className="p-0">
                                    <MDBContainer fluid >
                                        <div style={{margin:'15px 0'}}>
                                            <MDBRow>
                                                <MDBCol size="12" md="12" sm="12" className='flex-end'>
                                                    <div style={{
                                                        display: 'flex', justifyContent: 'flex-end'
                                                    }}>
                                                        <Space direction="vertical" size={12}>
                                                            <RangePicker
                                                                defaultValue={[moment(dateRange.startDate), moment(dateRange.endDate)]}
                                                                format={dateFormat}
                                                                onChange={handleDateRangeChange}
                                                                allowClear={false}
                                                            //disabledDate={disabledDate}
                                                            //disablePast
                                                            />
                                                            {/* <DatePicker defaultValue={moment('2015/01/01', dateFormat)} format={customFormat} /> */}
                                                        </Space>
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                            <TableData />
                                        </div>
                                    </MDBContainer>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </div>
            {
                data.length > 10 &&

                <MDBRow id="footerRow" style={{ width: "100%" }}>
                    <MDBFooter style={{ background: "#fff", position: "fixed", bottom: "0px", width: "100%", right: "0", borderTop: "1px solid #ccc", boxShadow: "0px 0 10px rgba(0, 0, 0, 0.2)", zIndex: "-1" }} color="white" className="pb-1 pt-1 text-right">

                        <MDBRow>
                            {/* <MDBCol> <span className=" float-right  bottom-0" style={{color:"black",left:"0",textAlign:'left'}}>Showing {this.state.pageNo} of {this.state.totalPages} pages</span></MDBCol>
                            <MDBCol></MDBCol> */}
                            <MDBCol>
                                <MDBPagination style={{ zIndex: "0" }} className=" float-right  bottom-0 right-0">
                                    <MDBPageItem>
                                        <MDBPageNav aria-label="Previous">
                                            <span aria-hidden="true" style={{ fontWeight: (paginate.page === 1 ? "" : "bold"), cursor: (paginate.page === 1 ? "auto" : "pointer"), color: localStorage.getItem("brand_color") }} onClick={prevPage}>Previous</span>
                                        </MDBPageNav>
                                    </MDBPageItem>
                                    <MDBPageItem>
                                        <MDBPageNav  >
                                            <span style={{ backgroundColor: "#2e3192", }} className="p-2 text-white pl-3 pr-3 ">{paginate.page === "" ? 1 : paginate.page}</span>

                                        </MDBPageNav>
                                    </MDBPageItem>

                                    <MDBPageItem>
                                        <MDBPageNav aria-label="Previous">
                                            <span aria-hidden="true" onClick={nextPage} style={{ fontWeight: (paginate.page === paginate.totalPages ? "" : "bold"), cursor: (paginate.page === paginate.totalPages ? "auto" : "pointer"), color: localStorage.getItem("brand_color") }}>Next</span>
                                        </MDBPageNav>
                                    </MDBPageItem>
                                </MDBPagination>
                            </MDBCol>
                        </MDBRow>
                    </MDBFooter>
                </MDBRow>
            }
        </div>
    )
}

export default TrackStickerVisa